import React from "react";
import styled from "styled-components";
import WifiOffOutlinedIcon from "@material-ui/icons/WifiOffOutlined";
import { useOnlineStatus } from "@sonder/ui/source/hooks/useOnlineStatus";
import { Toast } from "@sonder/ui/source/styled/fragments/Toast";

const Message = styled.span`
  flex: 1 1 auto;
  margin: 0 1rem;
`;

export const OfflineToast = () => {
  const { isOnline } = useOnlineStatus();
  if (isOnline) return null;
  return (
    <Toast>
      <WifiOffOutlinedIcon />
      <Message>You are currently offline, we are trying to reconnect.</Message>
    </Toast>
  );
};
